import React, { Fragment } from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input, } from 'reactstrap';
import { TableStriped } from '../../../components/tables/TableStriped';
import { useMicContainers } from '../../../hooks/micContainers/useMicContainers';
import { ModalMicContainers } from '../../../components/micContainers/ModalMicContainers';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';

export const IndexMicContainers = () => {
    const {
        // * LIST
        containersMic,

        // * PAGINATION
        totalPageCount, currentPage, nextPage, previousPage, goToPage, handleSearchContainer,

        //* CRUD TABLE
        handleCreate, handleUpdate, handleDelete, closeDialog, method, modal, tittle,
        name_container, handleInputChange, titleDelete,
        saveCreate, saveUpdate, saveDelete, loading, modalTitle, showDeleteAlert, closeDeleteAlert,
        modalAlert, handleExcelContainersMic, loadingExport, handleClear, handleSearch, searchContainer


    } = useMicContainers();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>

                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_container)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>

                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_container)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };


    return (
        <>
            <Fragment>
                <div className='container-global-zoom'>
                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody className="p-1">
                                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                        <TitleDataTable
                                            titleTable="Listado de contenedores"
                                            buttonActions={handleExcelContainersMic}
                                            titleButton="Listado de contenedores"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear Laboratorio"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearch}
                                            valueFilter={searchContainer}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClear}

                                        />
                                    </Col>

                                    <div className="table-responsive">
                                        <DataTable
                                            value={containersMic}
                                            paginator
                                            rows={10}
                                            responsiveLayout="scroll"
                                            rowsPerPageOptions={[10, 50, 100]}
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >

                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="name_container" header="Contenedor" headerStyle={headerStyle} style={cellStyle} />
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                        </DataTable>
                                    </div>

                                    {showDeleteAlert && (
                                        <AlertDataTable
                                            titleAlert="Eliminar Contenedores"
                                            visibleAlert={modalAlert}
                                            onHideAlert={closeDeleteAlert}
                                            sizeAlert="medium-dialog delete-method"
                                            messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el contenedor?"
                                            alert1={true}
                                            titleAlert1={name_container}
                                            buttonAcept
                                            titleNotLoading="Eliminar"
                                            titleDanger="Cancelar"
                                            actionAcept={saveDelete}
                                            maskClassName="custom-total-mask"
                                            newDesingDialog={true}
                                            iconNewDialog="fa fa-trash-o f-20"
                                            headerColor="#8b0000"
                                            newDesingDialogDelete={true}
                                            closable={false}
                                        />

                                    )}
                                </CardBody>
                            </Card>

                            {<ModalMicContainers
                                {...{
                                    modal, tittle, closeDialog, method, modalTitle,
                                    name_container,
                                    handleInputChange, loading, titleDelete,
                                    saveCreate, saveUpdate, saveDelete
                                }}
                            />}
                        </Col>
                    </Row>
                </div>
            </Fragment>
        </>
    )
}
